import { useSubscription } from "@/queries/subscription-queries";
import LoadingSpinner from "../loading-spinner";
import ExistingSubscription from "./ExistingSubscription";
import UpgradeSubscription from "./UpgradeSubscription";

export default function SubscriptionSettings() {
    const { data: subscriptionData, isLoading: isLoadingSubscription } = useSubscription();

    const hasSubscription = !!subscriptionData?.subscription;

    if (isLoadingSubscription) {
        return <LoadingSpinner />;
    }

    return (
        <div className="flex flex-col gap-2">
            {hasSubscription && <ExistingSubscription />}
            {!hasSubscription && <UpgradeSubscription />}
            <div className="checkout-container"></div>
        </div>
    );
}
